import React from "react";
import { Container, Row, Col, Carousel, Button } from "react-bootstrap";

export default function AdsSection() {

    const bigSlides = [
        { img: "/assets/1.png", btn: "Call Now" },
        { img: "/assets/2.png", btn: "Book Now" },
        { img: "/assets/3.png", btn: "Call Now" }
    ];

    const rightCards = [
        { img: "/assets/R1.png", btn: "Call Now" },
        { img: "/assets/R2.png", btn: "Book Now" },
        { img: "/assets/R3.png", btn: "Call Now" },
        { img: "/assets/R4.png", btn: "Book Now" }
    ];


    return (
        <section className="my-4">
            <Container>
                <Row className="g-4">

                    {/* LEFT SIDE BIG SLIDER */}
                    <Col md={7} style={{ position: "relative" }}>
                        <Carousel interval={1500} fade controls={false} indicators={false}>
                            {bigSlides.map((slide, index) => (
                                <Carousel.Item key={index}>

                                    <div
                                        className="rounded shadow-sm position-relative"
                                        style={{
                                            background: "#F4F7FB",
                                            width: "740px",
                                            height: "320px",        // ⬅⬅ Increase height here
                                            borderRadius: "12px",
                                            overflow: "hidden"

                                        }}
                                    >

                                        {/* PERFECT FULL STRETCH IMAGE */}
                                        <img
                                            src={slide.img}
                                            alt="slide"
                                            style={{
                                                width: "100%",   // stretches width
                                                height: "auto",  // keeps height correct
                                                display: "block" // removes small gaps
                                            }}
                                        />

                                        {/* BOTTOM LEFT BUTTON */}
                                        <Button
                                            className="px-4 py-2 fw-semibold"
                                            style={{
                                                position: "absolute",
                                                left: "15px",
                                                bottom: "15px",
                                                borderRadius: "8px",
                                                background: "#007bff",
                                                border: "none"
                                            }}
                                        >
                                            {slide.btn}
                                        </Button>
                                    </div>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    </Col>

                    {/* RIGHT SIDE CARDS */}
                    <Col md={5}>
                        <Row className="g-4">
                            {rightCards.map((card, index) => (
                                <Col xs={6} key={index}>
                                    <div
                                        className="position-relative shadow-sm"
                                        style={{
                                            borderRadius: "12px",
                                            overflow: "hidden",
                                            width: "250px",
                                            height: "150px",        // ⬅⬅ Increase height here
                                            backgroundColor: card.bg,
                                        }}
                                    >
                                        {/* FULL WIDTH IMAGE */}
                                        <img
                                            src={card.img}
                                            alt="promo"
                                            style={{
                                                width: "100%",
                                                height: "auto",
                                                objectFit: "cover", // fills card while keeping aspect
                                                display: "block",
                                            }}
                                        />

                                        {/* BOTTOM LEFT BUTTON */}
                                        <Button
                                            size="sm"
                                            className="fw-semibold"
                                            style={{
                                                position: "absolute",
                                                left: "10px",
                                                bottom: "10px",
                                                borderRadius: "4px",
                                                background: "#007bff",
                                                border: "none",
                                                padding: "4px 12px",
                                                fontSize: "0.8rem",
                                            }}
                                        >
                                            {card.btn || "Explore"}
                                        </Button>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>


                </Row>
            </Container>
        </section>
    );
}
